import { Stack, Typography } from '@mui/material';

const PLACEHOLDER = '—';

function DetailRow({ label, value }: { label: string; value: string }) {
  return (
    <Stack direction='row' gap='0.25rem' alignItems='center'>
      <Typography variant='caption' color='text.secondary' minWidth='120px'>
        {label}
      </Typography>
      <Typography variant='caption' color='text.primary'>
        {value}
      </Typography>
    </Stack>
  );
}

interface ConnectionDetailsSectionProps {
  isConnected: boolean;
}

export function ConnectionDetailsSection({ isConnected }: ConnectionDetailsSectionProps) {
  if (!isConnected) {
    return null;
  }

  return (
    <Stack gap='0.25rem'>
      <Typography variant='subtitle1'>Connection Details</Typography>
      <DetailRow label='Connected By:' value={PLACEHOLDER} />
      <DetailRow label='Last Updated By:' value={PLACEHOLDER} />
      <DetailRow label='Last Successful Sync:' value={PLACEHOLDER} />
    </Stack>
  );
}
